import * as tslib_1 from "tslib";
import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export var initializeDuperbrowse = createAction(actionKey + "/CONFIGURE", function (options) { return options; });
export var loadDuperbrowse = createAction(actionKey + "/LOAD", function (itemId, stream) { return ({ itemId: itemId, stream: stream }); });
export var openDuperbrowse = createAction(actionKey + "/OPEN", function (itemId, stream) {
    return (tslib_1.__assign({}, stream, { currentOpenItem: itemId, parent: tslib_1.__assign({}, stream.parent, { url: window.location.href }) }));
});
export var openDuperbrowsePreload = createAction(actionKey + "/OPEN", function (itemId, stream) {
    return (tslib_1.__assign({}, stream, { currentOpenItem: itemId, parent: tslib_1.__assign({}, stream.parent, { url: window.location.href }) }));
}, function (_, __, entities) { return ({ entities: entities }); });
export var exitDuperbrowse = createAction(actionKey + "/EXIT", function () { return null; });
export var exitDuperbrowseDone = createAction(actionKey + "/EXIT_DONE", function () { return null; });
export var moveNext = createAction(actionKey + "/NEXT", function () { return null; });
export var movePrev = createAction(actionKey + "/PREV", function () { return null; });
export var setCurrentItem = createAction(actionKey + "/SET_CURRENT_ITEM", function (itemId) { return ({ itemId: itemId }); });
export var setCurrentStreamAndItem = createAction(actionKey + "/SET_CURRENT_STREAM_AND_ITEM", function (streamId, itemId) { return ({ streamId: streamId, itemId: itemId }); });
export var shutdownDuperbrowse = createAction(actionKey + "/SHUTDOWN", function () { return null; });
export var loadDuperbrowseItem = createAction(actionKey + "/LOAD_ITEM", function (itemId, itemSchema, preloadDirection) { return ({
    itemId: itemId,
    itemSchema: itemSchema,
    preloadDirection: preloadDirection,
}); });
//# sourceMappingURL=actionCreators.js.map